export const CREDIT_PURCHASE_STATUS_LABELS: Record<string, string> = {
  initializing: 'Payment initializing',
  waiting: 'Waiting for payment',
  processing: 'Payment processing',
  paid: 'Paid',
  failed: 'Payment failed',
  cancelled: 'Cancelled',
};

/** Returns the customer-facing translation key for a credit-purchase status. */
export function creditPurchaseStatusLabel(status: string) {
  return CREDIT_PURCHASE_STATUS_LABELS[status] ?? 'Unknown status';
}
